import store from '../store'
import router from '../router'

const isSafeInternalPath = (path) => {
    if (typeof path !== 'string' || path.length === 0) return false
    if (!path.startsWith('/')) return false
    if (path.startsWith('//')) return false
    if (/^[a-z][a-z0-9+.-]*:/i.test(path)) return false
    return true
}

export const resolveNotificationRoute = (url = '') => {

    if (store.state.account) {
        let accountType = store.state.account.accountType
        if (accountType === 'coach_company') accountType = 'coach'
        url = url.replace(/\$account/, accountType)
    }

    if (!isSafeInternalPath(url)) {
        console.warn('Ignoring unsafe notification route:', url)
        return
    }

    store.commit('setRedirectRoute', url)
    router.replace(url).catch(() => { /* swallow navigation duplicated errors */ })
}
